/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export function shouldLogToEIM(url?: string): boolean {
  if (!url) {
    return true;
  }

  const filterList = ['mfe-c.static.workfront.com', 'esp-m.aptrinsic.com', 'esp.aptrinsic.com', 'app.pendo.io'];

  try {
    const {host} = new URL(url);
    const shouldFilter = filterList.some((url) => host.includes(url));
    return !(shouldFilter && Math.random() >= 0.01);
  } catch (e) {
    return true;
  }
}
